import type { WebSpecificStyle } from '../theme';
import { type StyleProp, StyleSheet, styleToCSS, type ViewStyle } from '../web';

export function convertStyleToCSS(
    style: StyleProp<ViewStyle> | StyleProp<WebSpecificStyle> | 'hidden' | 'visible'
): string;
export function convertStyleToCSS(style: StyleProp<ViewStyle> | 'hidden' | 'visible'): string;
/**
 * Generate a CSS string from style objects.
 */
export function convertStyleToCSS(
    style: StyleProp<ViewStyle> | StyleProp<WebSpecificStyle> | 'hidden' | 'visible'
): string {
    if (style === 'hidden') {
        return 'display: none;';
    }

    if (style === 'visible') {
        return 'display: flex;';
    }

    return styleToCSS(StyleSheet.flatten(style) as StyleProp<ViewStyle>);
}

/**
 * Insert CSS rules into the DOM.
 */
export function insertCSSStyle(css: string, group: number): void {
    if (typeof document === 'undefined') {
        return;
    }

    let styleElement = document.head.querySelector<HTMLStyleElement>(
        `style[data-gitbook-style-group="${group}"]`
    );
    if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.dataset.gitbookStyleGroup = String(group);
        document.head.appendChild(styleElement);
    }
    styleElement.appendChild(document.createTextNode(css));
}

/**
 * An identifier is associated with a unique set of styles.
 */
export function hashStyle(style: StyleProp<ViewStyle> | 'hidden' | 'visible'): string {
    if (style === undefined || style === null || style === false) {
        return '';
    }
    if (typeof style === 'string' || typeof style === 'number') {
        return `${style}`;
    }
    if (Array.isArray(style)) {
        return (style as Array<StyleProp<ViewStyle>>).map(hashStyle).join('-');
    }
    return Object.keys(style)
        .map((name) => {
            const hashedString = hash(`${name}:${JSON.stringify(style[name])}`);
            return process.env.NODE_ENV !== 'production'
                ? `${name}-${hashedString}`
                : `${hashedString}`;
        })
        .join('-');
}

function hash(value: string): string {
    let result = 2166136261;
    for (let index = 0; index < value.length; index += 1) {
        result ^= value.charCodeAt(index);
        result = Math.imul(result, 16777619);
    }
    return (result >>> 0).toString(36);
}
